__turbopack_context__.v({
  "container": "Textarea-module__264rza__container",
  "error": "Textarea-module__264rza__error",
  "errorText": "Textarea-module__264rza__errorText",
  "helperText": "Textarea-module__264rza__helperText",
  "label": "Textarea-module__264rza__label",
  "required": "Textarea-module__264rza__required",
  "textarea": "Textarea-module__264rza__textarea",
});
